import React from "react";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../../../contexts/userContext/userContext.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { plansStorages } from "utils/jumbomailSettings.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import UpgradeStorageModal from "../UpgradeStorageModal.js";
import { useModal } from "contexts/modalContext/modalContext.js";

const UserMailsAndStorageDetails = ({ userData }) => {
  const displayExtraStorage = !userData.IsSubUser;
  const { isPremium } = useUser();
  const { setModal } = useModal();
  const { getTextByKey } = useContent();
  const totalStorageByPlan = plansStorages[userData.userSubscriberSystemName];
  const percantegeOfSpace = ((userData.UserUsedStorage / userData.UserMaxStorage) * 100).toFixed(2);
  const currentExtraStorage = userData.NumOfExtraStorage;

  const replaceCurrentUsed = () => {
    let text = getTextByKey("profileuser-storage-usage");
    let usedSize = bytesToDisplayHelper(
      userData.UserUsedStorage,
      false,
      true
    ).size;
    let usedType = bytesToDisplayHelper(
      userData.UserUsedStorage,
      false,
      true
    ).type;
    let maxSize = bytesToDisplayHelper(
      userData.UserMaxStorage,
      false,
      true
    ).size;
    const percantegeOfSpace = (
      (userData.UserUsedStorage / userData.UserMaxStorage) *
      100
    ).toFixed(2);

    let maxType = bytesToDisplayHelper(
      userData.UserMaxStorage,
      false,
      true
    ).type;
    text = text.replaceAll("#USEDSPACE#", `${usedSize}${usedType}`);
    text = text.replaceAll("#TOTALSPACE#", `${maxSize}${maxType}`);
    return text;
  };

  const returnTotalStorage = () => {
    let maxSize = bytesToDisplayHelper(totalStorageByPlan, true, true).size;

    let maxType = bytesToDisplayHelper(totalStorageByPlan, true, true).type;
    return `${maxSize} ${maxType}`;
  };

  let mailsCount = 0;
  let filesCount = 0;

  if (userData.TotalUploadFilesCount && userData.TotalUploadFilesCount > 0) {
    filesCount = userData.TotalUploadFilesCount;
  }

  if (userData.UserTotalUploadMails && userData.UserTotalUploadMails > 0) {
    mailsCount = userData.UserTotalUploadMails;
  }

  const openModalExtraStorage = () => {
    //UpgradeStorageModal
    setModal({
      modal: UpgradeStorageModal,
    });
  };

  return (
    <div className="user-mail-storage-details">
      {userData.IsSubscribed && (
        <>
          <div className="title-card-storage">
            <h3 className="title">
              {getTextByKey("profileuser-mail-storage-title")}
              {displayExtraStorage && (
                <LinkToNewTab isNewTab page={"purchase/extra-storage"}>
                  <span
                    className="link-extra-storage"
                    //onClick={() => openModalExtraStorage()}
                  >
                    {getTextByKey("manage-extra-storage")}
                  </span>
                </LinkToNewTab>
              )}
            </h3>
            <Icon name="cloud-storage" xl />
          </div>
          <div className="total-size">
            {returnTotalStorage()}{" "}
            {currentExtraStorage > 0 && (
              <span className="num-of-extra-storage">
                {"+" + currentExtraStorage + "TB"}
              </span>
            )}
          </div>
          <div className="used-size-container">
            <div className="progress-and-text">
              <div className="used-size-text">{replaceCurrentUsed()}</div>
              <div className="progressbar">
                <div
                  className={`progress-fill ${
                    userData.UserMaxStorage > 0 ? "complete" : ""
                  }`}
                  style={{
                    width: `${
                      userData.UserMaxStorage > 0
                        ? userData.UserUsedStorage > userData.UserMaxStorage
                          ? 100
                          : (userData.UserUsedStorage /
                              userData.UserMaxStorage) *
                            100
                        : 0
                    }%`,
                    backgroundColor: `${
                      percantegeOfSpace > 95
                        ? "#a90500"
                        : percantegeOfSpace > 75
                        ? "#d9534f"
                        : "#51c7df"
                    }`,
                  }}
                ></div>
              </div>
            </div>
            <div className="percents">
              {!isNaN(percantegeOfSpace) && (
                <div className="precentage-used">{percantegeOfSpace}%</div>
              )}
            </div>
          </div>
        </>
      )}
      <div className="mail-files-details-container">
        <div className="total-sent-title">
          {getTextByKey("profileuser-total-sent-mails")}
        </div>
        <div className="file-and-mails-details">
          
            <div className="item-details">
              <Icon name="envelope" className="icon" ext="png" xxl />
              <div className="item-details-text">
                {`${mailsCount} ${getTextByKey("mails-details-text")}`}
              </div>
            </div>
          
            <div className="item-details">
              <Icon name="file" className="icon" ext="png" xl />
              <div className="item-details-text">
                {`${filesCount} ${getTextByKey("files-details-text")}`}
              </div>
            </div>
          
        </div>
      </div>
    </div>
  );
};

export default UserMailsAndStorageDetails;
